import React, { useState, useEffect } from 'react';

const ApiDocsPage = () => {
    const [activeTab, setActiveTab] = useState('overview');
    const [activeCodeTab, setActiveCodeTab] = useState('javascript');

    useEffect(() => {
        document.title = 'PayzoPay - API Dokümantasyonu';
    }, []);

    const baseUrl = window.location.origin + '/api/v1';

    const tabStyle = (tabName) => ({
        padding: '12px 20px', cursor: 'pointer', borderBottom: activeTab === tabName ? '3px solid #007bff' : '3px solid transparent',
        color: activeTab === tabName ? '#007bff' : 'var(--text-color)', fontWeight: activeTab === tabName ? 'bold' : 'normal',
        transition: 'all 0.3s'
    });

    const codeTabStyle = (tabName) => ({
        padding: '8px 15px', cursor: 'pointer',
        backgroundColor: activeCodeTab === tabName ? '#333' : '#1e1e1e',
        color: activeCodeTab === tabName ? '#fff' : '#aaa',
        border: 'none', borderTopLeftRadius: '5px', borderTopRightRadius: '5px', marginRight: '2px'
    });

    const codeBlockStyle = {
        backgroundColor: '#1e1e1e', color: '#d4d4d4', padding: '20px', borderRadius: '0 5px 5px 5px',
        overflowX: 'auto', fontFamily: 'monospace', fontSize: '0.9em', margin: '0', lineHeight: '1.5'
    };

    const badgeStyle = (color) => ({
        backgroundColor: color, color: '#fff', padding: '3px 8px', borderRadius: '4px', fontSize: '0.8em', fontWeight: 'bold', marginRight: '10px'
    });

    return (
        <div style={{ padding: '20px', color: 'var(--text-color)' }}>
            <div style={{ backgroundColor: 'var(--card-bg)', padding: '20px', borderRadius: '8px', marginBottom: '20px', boxShadow: 'var(--shadow)' }}>
                <h2 style={{ marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className="fas fa-book"></i> API Dokümantasyonu
                </h2>
                <p style={{ color: '#6c757d' }}> Kendi sisteminize entegrasyon icin bu API dokumanini kullanin</p>
            </div>

            <div style={{ display: 'flex', borderBottom: '1px solid var(--border-color)', marginBottom: '20px', overflowX: 'auto' }}>
                <div onClick={() => setActiveTab('overview')} style={tabStyle('overview')}>Genel Bakış</div>
                <div onClick={() => setActiveTab('auth')} style={tabStyle('auth')}>Kimlik Doğrulama</div>
                <div onClick={() => setActiveTab('deposits')} style={tabStyle('deposits')}>Yatırım API</div>
                <div onClick={() => setActiveTab('withdrawals')} style={tabStyle('withdrawals')}>Çekim API</div>
                <div onClick={() => setActiveTab('status')} style={tabStyle('status')}>Durum Sorgulama</div>
            </div>

            <div style={{ backgroundColor: 'var(--card-bg)', padding: '30px', borderRadius: '8px', boxShadow: 'var(--shadow)' }}>
                {activeTab === 'overview' && (
                    <div>
                        <h3>API Genel Bakışı</h3>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' }}>
                            <div style={{ padding: '15px', backgroundColor: 'var(--input-bg)', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
                                <h4 style={{ margin: '0 0 10px 0' }}>Base URL</h4>
                                <code style={{ backgroundColor: 'rgba(0,0,0,0.1)', padding: '5px 10px', borderRadius: '4px', display: 'block' }}>{baseUrl}</code>
                            </div>
                            <div style={{ padding: '15px', backgroundColor: 'var(--input-bg)', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
                                <h4 style={{ margin: '0 0 10px 0' }}>Content-Type</h4>
                                <code style={{ backgroundColor: 'rgba(0,0,0,0.1)', padding: '5px 10px', borderRadius: '4px', display: 'block' }}>application/json</code>
                            </div>
                        </div>

                        <h4>Mevcut Endpoint'ler</h4>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div style={{ padding: '15px', backgroundColor: 'var(--input-bg)', borderRadius: '8px', display: 'flex', alignItems: 'center' }}>
                                <span style={badgeStyle('#28a745')}>POST</span>
                                <code style={{ flex: 1 }}>/api/v1/deposits</code>
                                <span style={{ color: '#6c757d', fontSize: '0.9em' }}>Yeni yatırım talebi oluştur</span>
                            </div>
                            <div style={{ padding: '15px', backgroundColor: 'var(--input-bg)', borderRadius: '8px', display: 'flex', alignItems: 'center' }}>
                                <span style={badgeStyle('#28a745')}>POST</span>
                                <code style={{ flex: 1 }}>/api/v1/withdrawals</code>
                                <span style={{ color: '#6c757d', fontSize: '0.9em' }}>Yeni çekim talebi oluştur</span>
                            </div>
                            <div style={{ padding: '15px', backgroundColor: 'var(--input-bg)', borderRadius: '8px', display: 'flex', alignItems: 'center' }}>
                                <span style={badgeStyle('#007bff')}>GET</span>
                                <code style={{ flex: 1 }}>/api/v1/transactions/:id</code>
                                <span style={{ color: '#6c757d', fontSize: '0.9em' }}>İşlem durumu sorgula</span>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'auth' && (
                    <div>
                        <h3>Kimlik Doğrulama</h3>
                        <div style={{ padding: '15px', backgroundColor: 'rgba(255, 193, 7, 0.1)', border: '1px solid #ffc107', borderRadius: '8px', marginBottom: '20px', color: '#856404' }}>
                            <i className="fas fa-exclamation-triangle"></i> <strong>Önemli:</strong> Tüm API isteklerinde aşağıdaki header bilgileri zorunludur. API anahtarlarınızı güvenli tutun.
                        </div>

                        <h4>Gerekli Header'lar</h4>
                        <pre style={codeBlockStyle}>
                            {`X-API-Key: pk_xxxxxxxxxxxxxxxxxxxxxxxx
X-Secret-Key: sk_xxxxxxxxxxxxxxxxxxxxxxxx
Content-Type: application/json`}
                        </pre>

                        <h4 style={{ marginTop: '30px' }}>Hata Kodları</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <tbody>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td style={{ padding: '10px', color: '#dc3545', fontFamily: 'monospace' }}>API_KEY_REQUIRED</td><td style={{ padding: '10px' }}>API anahtarı veya secret key eksik</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td style={{ padding: '10px', color: '#dc3545', fontFamily: 'monospace' }}>INVALID_CREDENTIALS</td><td style={{ padding: '10px' }}>Geçersiz API anahtarı veya secret key</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td style={{ padding: '10px', color: '#dc3545', fontFamily: 'monospace' }}>API_KEY_DISABLED</td><td style={{ padding: '10px' }}>API anahtarı pasif durumda</td></tr>
                            </tbody>
                        </table>
                    </div>
                )}

                {activeTab === 'deposits' && (
                    <div>
                        <h3>Yatırım Talebi Oluşturma</h3>
                        <p><span style={badgeStyle('#28a745')}>POST</span> <code>/api/v1/deposits</code></p>

                        <h4>İstek Body Parametreleri</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px', fontSize: '0.9em' }}>
                            <thead style={{ backgroundColor: 'var(--table-header-bg)' }}>
                                <tr><th style={{ padding: '10px', textAlign: 'left' }}>Alan</th><th style={{ padding: '10px', textAlign: 'left' }}>Tip</th><th style={{ padding: '10px', textAlign: 'left' }}>Zorunlu</th><th style={{ padding: '10px', textAlign: 'left' }}>Açıklama</th></tr>
                            </thead>
                            <tbody>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>fullname</code></td><td>string</td><td><span style={{ color: '#dc3545' }}>Evet</span></td><td>Kullanıcının tam adı</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>amount</code></td><td>number</td><td><span style={{ color: '#dc3545' }}>Evet</span></td><td>Yatırım tutarı (TL)</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>bankName</code></td><td>string</td><td><span style={{ color: '#dc3545' }}>Evet</span></td><td>Banka adı</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>userId</code></td><td>string</td><td>Hayır</td><td>Sisteminizdeki kullanıcı ID'si</td></tr>
                            </tbody>
                        </table>

                        <h4>Örnek İstek</h4>
                        <pre style={codeBlockStyle}>
                            {`{
  "fullname": "Ahmet Yılmaz",
  "amount": 1500.00,
  "bankName": "Ziraat Bankası",
  "userId": "user_12345"
}`}
                        </pre>

                        <h4>Başarılı Yanıt</h4>
                        <pre style={codeBlockStyle}>
                            {`{
  "success": true,
  "data": {
    "transactionId": "6578f...",
    "status": "pending",
    "amount": 1500,
    "createdAt": "2024-12-11T10:00:00.000Z"
  }
}`}
                        </pre>
                    </div>
                )}

                {activeTab === 'withdrawals' && (
                    <div>
                        <h3>Çekim Talebi Oluşturma</h3>
                        <p><span style={badgeStyle('#28a745')}>POST</span> <code>/api/v1/withdrawals</code></p>

                        <h4>İstek Body Parametreleri</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px', fontSize: '0.9em' }}>
                            <thead style={{ backgroundColor: 'var(--table-header-bg)' }}>
                                <tr><th style={{ padding: '10px', textAlign: 'left' }}>Alan</th><th style={{ padding: '10px', textAlign: 'left' }}>Tip</th><th style={{ padding: '10px', textAlign: 'left' }}>Zorunlu</th><th style={{ padding: '10px', textAlign: 'left' }}>Açıklama</th></tr>
                            </thead>
                            <tbody>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>fullname</code></td><td>string</td><td><span style={{ color: '#dc3545' }}>Evet</span></td><td>Hesap sahibinin tam adı</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>amount</code></td><td>number</td><td><span style={{ color: '#dc3545' }}>Evet</span></td><td>Çekim tutarı (TL)</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>bankName</code></td><td>string</td><td><span style={{ color: '#dc3545' }}>Evet</span></td><td>Banka adı</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>iban</code></td><td>string</td><td><span style={{ color: '#dc3545' }}>Evet</span></td><td>IBAN numarası</td></tr>
                                <tr style={{ borderBottom: '1px solid var(--border-color)' }}><td><code>userId</code></td><td>string</td><td>Hayır</td><td>Sisteminizdeki kullanıcı ID'si</td></tr>
                            </tbody>
                        </table>

                        <h4>Örnek İstek</h4>
                        <pre style={codeBlockStyle}>
                            {`{
  "fullname": "Mehmet Demir",
  "amount": 2500.00,
  "bankName": "İş Bankası",
  "iban": "TR330006100519786457841326",
  "userId": "user_67890"
}`}
                        </pre>
                    </div>
                )}

                {activeTab === 'status' && (
                    <div>
                        <h3>İşlem Durumu Sorgulama</h3>
                        <p>Henüz bu özellik aktif değildir. İşlem durumları Callback URL'lerinize POST isteği olarak gönderilir.</p>
                    </div>
                )}
            </div>

            {/* Kod Örnekleri Kartı */}
            <div style={{ backgroundColor: 'var(--card-bg)', padding: '20px', borderRadius: '8px', marginTop: '20px', boxShadow: 'var(--shadow)' }}>
                <h3 style={{ marginTop: 0 }}><i className="fas fa-code"></i> Entegrasyon Kod Örnekleri</h3>

                <div>
                    <button onClick={() => setActiveCodeTab('javascript')} style={codeTabStyle('javascript')}>JavaScript</button>
                    <button onClick={() => setActiveCodeTab('php')} style={codeTabStyle('php')}>PHP</button>
                    <button onClick={() => setActiveCodeTab('python')} style={codeTabStyle('python')}>Python</button>
                </div>

                {activeCodeTab === 'javascript' && (
                    <pre style={codeBlockStyle}>
                        {`const API_KEY = 'pk_your_api_key';
const SECRET_KEY = 'sk_your_secret_key';
const BASE_URL = '${baseUrl}';

async function createDeposit(data) {
  const response = await fetch(\`\${BASE_URL}/deposits\`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': API_KEY,
      'X-Secret-Key': SECRET_KEY
    },
    body: JSON.stringify(data)
  });
  return response.json();
}`}
                    </pre>
                )}

                {activeCodeTab === 'php' && (
                    <pre style={codeBlockStyle}>
                        {`<?php
$apiKey = 'pk_your_api_key';
$secretKey = 'sk_your_secret_key';
$baseUrl = '${baseUrl}';

$ch = curl_init($baseUrl . '/deposits');
curl_setopt_array($ch, [
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_POST => true,
    CURLOPT_POSTFIELDS => json_encode($data),
    CURLOPT_HTTPHEADER => [
        'Content-Type: application/json',
        'X-API-Key: ' . $apiKey,
        'X-Secret-Key: ' . $secretKey
    ]
]);
$response = curl_exec($ch);
curl_close($ch);`}
                    </pre>
                )}

                {activeCodeTab === 'python' && (
                    <pre style={codeBlockStyle}>
                        {`import requests

headers = {
    'Content-Type': 'application/json',
    'X-API-Key': 'pk_your_api_key',
    'X-Secret-Key': 'sk_your_secret_key'
}

response = requests.post(f'{BASE_URL}/deposits', json=data, headers=headers)
print(response.json())`}
                    </pre>
                )}
            </div>
        </div>
    );
};

export default ApiDocsPage;